import * as React from 'react';
import { Badge, Grid, List, makeStyles } from '@material-ui/core';
import { ListItem, Text } from '@topconagriculture/react-components';
import { border, toCssValue } from '@topconagriculture/theme';
import { useI18nFormat } from '@topconagriculture/language';
import { useTranslation } from 'react-i18next';
import { useReadPlatformNotifications } from '../../hooks/useReadPlatformNotifications';
const useStyles = makeStyles((theme) => ({
    listContainer: {
        display: 'flex',
        flexDirection: 'column',
        flex: '1 0 0',
    },
    list: {
        backgroundColor: theme.color.background.light,
        padding: toCssValue([5, 5]),
        border: border(theme.color.grey.light),
        borderRadius: 5,
        position: 'relative',
        width: '100%',
        overflow: 'auto',
        maxHeight: '100%',
        '& .MuiListItem-root.Mui-selected': {
            backgroundColor: theme.color.primary.main,
            color: 'white',
        }
    },
    listItem: {
        padding: theme.space.padding.small,
        fontSize: 14,
        borderBottom: border(theme.color.grey.light),
        '&:last-child': {
            borderBottom: 'none',
        },
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    badge: {
        '& .MuiBadge-badge': {
            margin: 10,
            height: 11,
            minWidth: 10,
        }
    },
    readAll: {
        display: 'flex',
        justifyContent: 'end',
        margin: toCssValue([2, 5]),
        textDecoration: 'underline',
        cursor: 'pointer',
    },
}));
const NotificationList = ({ notifications, selected, setSelected, activeIndexList }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { formatDateTime } = useI18nFormat();
    const { isNotificationRead, readNotification } = useReadPlatformNotifications();
    React.useMemo(() => {
        if (activeIndexList.includes(selected === null || selected === void 0 ? void 0 : selected.id) && !isNotificationRead(selected === null || selected === void 0 ? void 0 : selected.id)) {
            readNotification(selected === null || selected === void 0 ? void 0 : selected.id);
        }
    }, [selected]);
    const handleReadAll = () => {
        activeIndexList.forEach((index) => readNotification(index));
    };
    return (React.createElement("div", { className: classes.listContainer },
        React.createElement("div", { className: classes.readAll, onClick: handleReadAll }, `${t('common:read_all')} (${activeIndexList.length})`),
        React.createElement(List, { className: classes.list }, notifications.map((item, index) => (React.createElement(ListItem, { className: classes.listItem, onClick: () => setSelected(item), selected: item.id === (selected === null || selected === void 0 ? void 0 : selected.id), key: index },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { item: true, xs: 12, className: classes.row },
                    React.createElement(Text, { bold: true, size: 16 }, t('common:platform_notifications.' + item.type)),
                    activeIndexList.includes(item.id) && React.createElement(Badge, { color: "error", badgeContent: " ", className: classes.badge })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(Text, { size: 12 }, formatDateTime(item.notificationStartDate))))))))));
};
export default NotificationList;
//# sourceMappingURL=NotificationList.js.map